<template>
  <MarkdownPost markdown-file="symbolic-thinking.md" />
</template>

<script>
import MarkdownPost from '../MarkdownPost.vue'

export default {
  name: 'SymbolicThinking',
  components: {
    MarkdownPost
  }
}
</script>
